exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.message-title[data-v-cf51e862] {\n\tfont-size: 16px;\n\tcolor: #333;\n\tfont-weight: bold;\n\tpadding-right: 8px;\n}\n", ""]);

// exports
